<template>
  <v-dialog v-model="show" max-width="500px">
    <v-card>
        <v-card color="#FFD375" class="elevation-12">
            <v-toolbar color="#FFA500">
                <v-toolbar-title>{{title}}</v-toolbar-title>
            </v-toolbar>

            <v-card color="#FFD375" flat class="elevation-12">
                <v-toolbar class="mt-1" color="#FFA500" flat>
                    <v-toolbar-title flat>Available</v-toolbar-title>
                </v-toolbar>
                <v-container :key="selectedgroups.length">
                    <span v-for="groupchip in availablegroups" :key="groupchip.ID">
                        <v-chip class="ma-1" @click="chipAvailableClick(groupchip)">{{groupchip.Name}}</v-chip>
                    </span>
                </v-container>
            </v-card>

            <v-card color="#FFD375" flat class="elevation-12">
                <v-toolbar class="mt-1" color="#FFA500" flat>
                    <v-toolbar-title flat>Selected</v-toolbar-title>
                </v-toolbar>
                    <v-container :key="selectedgroups.length">
                        <span v-for="groupchip in selectedgroups" :key="groupchip.ID">
                            <v-chip class="ma-1" @click="chipSelectedClick(groupchip)">{{groupchip.Name}}<v-icon right>highlight_off</v-icon></v-chip>
                        </span>
                    </v-container>
            </v-card>

            <v-card-actions>
                <v-btn color="#FFA500" @click="cancel" data-cy="joinSubmitBtn">CANCEL</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="#FFA500" :disabled="!changed" @click="submit" data-cy="joinSubmitBtn">CONFIRM</v-btn>
            </v-card-actions>
        </v-card>
        </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
        value: Boolean,
      contact:Object
  },
  data() {
      return {
          changed: false,
          availablegroups: [],
          selectedgroups: [],
          originalselectedgroups:[]
      };
  },
  computed: {
    show: {
      get () {
        this.initialiseData();
        return this.value
      },
      set(value) {
        this.changed = false;
        this.$emit('input', value)
      }
    },
      title() {
        if (!this.contact)
            return 'Groups for';
        return 'Groups for ' + this.contact.Name;
    }
    
  },
  methods: {
      initialiseData() {
          if ((this.contact) && (!this.changed)) {
              this.selectedgroups = [];
              this.availablegroups = [];
              this.originalselectedgroups = [];
              //go through all of my groups and put them into availablegroups or selectedgroups
              this.$store.state.groups.forEach(group => {
                  if (this.isSelected(group.ID)) {
                      this.selectedgroups.push({ Name: group.Name, ID: group.ID });
                      this.originalselectedgroups.push(group);
                  }
                  else
                      this.availablegroups.push({ Name: group.Name, ID: group.ID })
              });
              this.availablegroups.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
              this.selectedgroups.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
          }
      },
      isSelected(id) {
          if ((this.contact == null) || (this.contact.Groups == null))
              return false;
          var found = false;
          this.contact.Groups.forEach(grp => {
              if (id === grp)
                  found=true;
          });
          return found;
      },
      inGroupList(id,list) {
          var found = false;
          list.forEach(grp => {
              if (id === grp.ID)
                  found = true;
          });
          return found;
      },
      findIndex(id, list) {
          var index = 0;
          var found = -1;
          if (list == null)
              return -1;
          list.forEach(grp => {
              if (id === grp)
                  found = index;
              index++;
          });
          return found;
      },
      chipAvailableClick(chip) {
          const index = this.availablegroups.indexOf(chip);
          this.availablegroups.splice(index, 1);
          this.selectedgroups.push(chip);
          this.selectedgroups.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
          this.changed = true;
      },
      chipSelectedClick(chip) {
          const index = this.selectedgroups.indexOf(chip);
          this.selectedgroups.splice(index, 1);
          this.availablegroups.push(chip);
          this.availablegroups.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
          this.changed = true;
      },
      findMyGroup(id) {
          var found = null;
          this.$store.state.groups.forEach(group => {
              if (group.ID === id)
                  found = group;
          });
          return found;
      },
      cancel(){
          this.show = false;
      },
      submit() {
          // here we action additions 
          this.selectedgroups.forEach(group => {
              if (!this.inGroupList(group.ID, this.originalselectedgroups)) {
                  if (this.contact.Groups == null)
                      this.contact.Groups = [];
                  this.contact.Groups.push(group.ID);

                  var mygroup = this.findMyGroup(group.ID);
                  const cindex = this.findIndex(this.contact.ID, mygroup.Contacts);
                  if (cindex < 0) {
                      mygroup.Contacts.push(this.contact.ID);
                      this.$store.dispatch('setGroup', mygroup);
                  }
              };
          });
          // and then removals
          this.originalselectedgroups.forEach(group => {
              if (!this.inGroupList(group.ID, this.selectedgroups)) {
                  const gindex = this.findIndex(group.ID, this.contact.Groups);
                  this.contact.Groups.splice(gindex, 1);

                  var mygroup = this.findMyGroup(group.ID);
                  const cindex = this.findIndex(this.contact.ID, mygroup.Contacts);
                  if (cindex >= 0) {
                      mygroup.Contacts.splice(cindex, 1);
                      this.$store.dispatch('setGroup', mygroup);
                  }
              };
          });
          this.$store.dispatch('setContact', this.contact);
          this.show = false;
        }
  }
}
</script>